var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-timeline',_vm._b({attrs:{"reverse":_vm.isReversed}},'el-timeline',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }